
const reports = {
    "ATE_REPORTS":{
        name:'Ate Report',
        path:`custom/ate`
    }
}

export default reports;